/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manager_Question_SaveInputs */



/**
* | output |
* | --- |
* | "Save" |
*
* @param {Manager_Question_SaveInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manager_question_save = /** @type {((inputs?: Manager_Question_SaveInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manager_Question_SaveInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Bewaren")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer")
	return /** @type {LocalizedString} */ ("Save")
});